(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/board-container.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/board-container.js');

'use strict';

svs.numbergames.game.views.BoardContainer = Marionette.View.extend({
  boardButtonsView: svs.numbergames.game.views.BoardButtons,
  boardView: svs.numbergames.game.views.Board,
  regions: {
    boardRegion: '#boardRegion',
    buttonsRegion: '#buttonsRegion'
  },
  collectionEvents: {
    'active:board:changed': 'renderBoard'
  },
  className: 'board-container',
  template(data) {
    return svs.numbergames.game.templates.board_container(data);
  },
  initialize() {
    svs.numbergames.game.logger.debug('svs.numbergames.game.views.BoardContainer initialized');
    this.collection = this.model.get('boards');
  },
  onRender() {
    this.renderBoard(this.collection.getActive());
    const boardButtonsView = this.getOption('boardButtonsView');
    this.showChildView('buttonsRegion', new boardButtonsView({
      collection: this.collection,
      productId: this.model.get('productId')
    }));
  },
  renderBoard(model) {
    const boardView = this.getOption('boardView');
    this.showChildView('boardRegion', new boardView({
      model
    }));
  }
});

 })(window);